import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image2 from "../../../../assets/images/blog14-2.png";
import image5 from "../../../../assets/images/blog14-5.png";
import image28 from "../../../../assets/images/blog14-28.png";
import image16 from "../../../../assets/images/blog14-16.png";
import image8 from "../../../../assets/images/blog14-8.png";
import image23 from "../../../../assets/images/blog14-23.png";
import image15 from "../../../../assets/images/blog14-15.png";
import image10 from "../../../../assets/images/blog14-10.png";
import image21 from "../../../../assets/images/blog14-21.png";
import image25 from "../../../../assets/images/blog14-25.png";
import image11 from "../../../../assets/images/blog14-11.png";
import image27 from "../../../../assets/images/blog14-27.png";
import image14 from "../../../../assets/images/blog14-14.png";
import image13 from "../../../../assets/images/blog14-13.png";
import image3 from "../../../../assets/images/blog14-3.png";
import image1 from "../../../../assets/images/blog14-1.png";
import image22 from "../../../../assets/images/blog14-22.png";
import image6 from "../../../../assets/images/blog14-6.png";

const Blog14 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook: April 15, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Tariffs, Tech, and Tactical Bottoms
        </p>
        <div className="subHeader">
          <p className=""> This week’s trading forecast dives into tariff turmoil, macro crosscurrents, tech tremors, and golden momentum. Markets flirt with a bottom as volatility spikes.</p>
          <hr className="divisionLine" />

          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedText_header">Market Overview: Bottoming or Just Bouncing?</p>
              <p>
                Last week was peak macro theater. Tariffs, fake news headlines, and bond market fireworks kept traders pinned to terminals. Equities staged a powerful bounce, but was it the start of
                something real—or just another dead cat in a bear suit?
              </p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UoM sentiment at 2009 lows</span>
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">VIX spiked, then reversed sharply midweek</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">S&P’s 2-day bounce among strongest in decades</span>
                  </p>
                </li>
              </ul>
              <p>Fear is thick, but so is opportunity.</p>
            </div>
          </div>
        </div>
        <div className="imageWrapperCont">
          <div className="relatedImg">
            <img
              src={image2}
              alt=""
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image2)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
          <div className="relatedImg">
            <img
              src={image5}
              alt=""
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image5)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
          <div className="relatedImg">
            <img
              src={image28}
              alt=""
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image28)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <p className="highlightedBoldText">Macro & Policy Watch: Tariff Fireworks & Bond Tantrums</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Trump’s Tech Targeting</p>
                {/* <p>Taiwan chipmakers and Indian reroutes dominate the Section 232 narrative. The tariff “pause” was a head-fake—except for China, which remains the real target. </p> */}
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>Supply chains are a mess—Apple, Broadcom, and TSMC caught in the blast zone.</p>
                  </li>

                  <li className="themesPointer">
                    <p>Broadcom’s $10B buyback was both signal and shield.</p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={image16}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image16)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Bonds: Dysfunctional by Design?</p>
                <p>The US10Y nearly touched 4.5% as yields screamed higher across the board. The market is panicking about inflation—but the Fed? Silent.</p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>ECB set to cut 25bps this week.</p>
                  </li>

                  <li className="themesPointer">
                    <p>Cross-border bond selling suggests real stress, not just rate expectations.</p>
                  </li>
                  <li className="themesPointer">
                    <p>DXY breakdown adds to the confusion.</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image23}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image23)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image15}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image15)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr className="divisionLine" />
        </div>

        <div className="subHeader">
          <p className="highlightedBoldText">Earnings & Data Calendar: Q2 Starts Loud</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Corporate Highlights:</p>
                <p>Taiwan chipmakers and Indian reroutes dominate the Section 232 narrative. The tariff “pause” was a head-fake—except for China, which remains the real target. </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Bank Earnings Roll In: </span>
                      GS, BoA, JPM, MS all reporting
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Tech Watch: </span>Netflix & TSMC midweek—huge sentiment movers
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Luxury Pulse: </span> LVMH, Hermes, L’Oréal = global consumer barometers
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Macro Data to Track: </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">China GDP </span>
                      and credit impulse: Does deflation risk deepen?
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">US Retail Sales </span>and PPI: More signals for the Fed
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">ECB decision: </span> How dovish can Lagarde afford to sound?
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image10}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image10)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image21}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image21)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image25}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image25)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr className="divisionLine" />
        </div>

        <div className="subHeader">
          <p className="highlightedBoldText">Technical Setups & Sentiment </p>
          <div className="subHeader">
            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Gold: Exhaustion or Just a Breather? </p>

                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>Made fresh all-time highs, but RSI divergence suggests caution.</p>
                  </li>
                  <li className="themesPointer">
                    <p>Silver lagging = possible retracement incoming.</p>
                  </li>
                </ul>
              </div>
              <div className="relatedImg">
                <img
                  src={image11}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image11)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Oil: Structural Breakdown Confirmed </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>Sub-$60 barrel for first time since 2021.</p>
                  </li>
                  <li className="themesPointer">
                    <p>OPEC cuts not enough to halt momentum—demand risk in full focus.</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image27}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image27)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image14}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image14)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Equities: Tactical Rally or Trap? </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>SPX putting in higher lows, but breadth weak. </p>
                  </li>
                  <li className="themesPointer">
                    <p>Risk-on mode may return if TSMC and Netflix impress.</p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image13}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image13)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image3}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image3)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr className="divisionLine" />
        </div>
        <p className="highlightedBoldText">Upcoming Week Preview: Day-by-Day Breakdown </p>
        <p>
          This week has the hallmarks of a macro minefield—China’s growth pulse, US consumer resilience, ECB guidance, and early Q1 earnings. With risk assets rattled and bonds volatile, every data
          point matters. Here’s what to watch, day by day.
        </p>

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Monday, April 15</p>
                <p className="highlightedText">Bank earnings begin + US Treasury auctions</p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      {" "}
                      <span className="highlightedText">Goldman Sachs (GS)</span> and <span className="highlightedText">M&T Bank </span>kick off earnings season with insight into consumer credit and
                      investment banking flows.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>Treasury auctions continue to test appetite for duration after last week’s bond rout.</p>
                  </li>
                  <li className="themesPointer">Traders will also eye early market sentiment after last week's wild swings in rates and risk. </li>
                </ul>
              </div>

              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Tuesday, April 16 </p>
                <p className="highlightedText">China credit pulse + European credit stress </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      {" "}
                      <span className="highlightedText">China’s Aggregate Financing </span> and <span className="highlightedText"> Loan Growth </span>will show if Beijing’s reflation push is gaining
                      traction.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>In Europe, continued scrutiny on banks and periphery spreads ahead of Thursday’s ECB.</p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      US<span className="highlightedText"> Industrial Production </span>could hint at underlying capex and manufacturing softness.{" "}
                    </p>
                  </li>
                </ul>
              </div>

              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image22}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image22)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Wednesday, April 17 </p>
                <p className="highlightedText">Triple Threat: US Retail Sales, China GDP, Netflix </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      {" "}
                      <span className="highlightedText">US March Retail Sales </span> is the macro print of the week. Strong data would undermine rate-cut expectations and challenge the market’s
                      soft-landing view.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">China Q1 GDP, Retail Sales, </span>and <span className="highlightedText">Industrial Production</span>are due pre-US open—setting the global
                      tone.{" "}
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      After hours,<span className="highlightedText"> Netflix (NFLX) </span>earnings will be closely watched for subscriber growth, engagement metrics, and content cost outlook.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image16}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image16)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Thursday, April 18</p>
                <p className="highlightedText">ECB + TSMC + BOC = Volatility Triad </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">ECB Rate Decision: </span> Market expects 25bps, but will Lagarde lean into future cuts? Euro, bunds, and EU credit will react.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">TSMC Earnings: </span>Seen as the AI supply chain proxy. Soft guidance could ripple across semis and Nasdaq.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Bank of Canada Rate Decision: </span> No cut expected, but language could turn dovish amid weakening Canadian labor data.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Atlanta Fed GDPNow Update </span> due after key consumption and inventory revisions—watch this closely as Q1 growth estimates are recalibrated.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="imageWrapper">
                <div className="relatedImg">
                  <img
                    src={image25}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image25)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap ">
              <div className="listImgWrapper">
                <p className=" highlightedText_header">Friday, April 19 – Good Friday </p>
                <p className="highlightedText">Western Markets Closed </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText"> No major US data releases</span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">NYSE, Nasdaq, CME closed </span>
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>Expect thin liquidity into the weekend—positioning will likely be squared Thursday into the long weekend.</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <p className="highlightedBoldText">Actionable Takeaway: Macro Mayhem = Trader’s Playground </p>
          <p>Traders should approach this environment with tactical discipline. There’s signal through the noise—but it requires zooming in when the rest of the market is zoomed out.</p>
          <div className="subHeader">
            <div className="contentDivWrapper">
              <div className="contentDiv listOfRecap ">
                <div className="listImgWrapper">
                  <p className=" highlightedText_header">Key Alpha Reads: </p>

                  <ul className="pointersSection">
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText"> Rate cut expectations rising,</span> even if central banks deny it
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Gold may correct,</span> but long-term momentum intact
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Bond volatility = equity fragility</span>
                      </p>
                    </li>
                    <li className="themesPointer">
                      <p>
                        <span className="highlightedText">Watch Netflix & TSMC </span>or sentiment pivot this week
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/13njWT1IgRI1ezCj8yvh_KsvbUyThaCxVs9KnOxxVjOY/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>

      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog14;
